import { useI18n } from 'builder/hooks/useI18n'
import { SpinnerLight } from 'builder/components/Spinner'

import { TRANSLATION } from '../constants'
import * as Styles from './styles'

export const LoadingState = () => {
  return (
    <Styles.SkeletonContainer>
      <Styles.SkeletonImageContainer>
        <Styles.SkeletonImage />
        <Styles.SkeletonFadeResume />
      </Styles.SkeletonImageContainer>
      <Styles.SkeletonInfo>
        <Styles.SkeletonHeader />
        <Styles.SkeletonDescription />
      </Styles.SkeletonInfo>
    </Styles.SkeletonContainer>
  )
}

export const ProcessingState = () => {
  const { i18n } = useI18n()

  return (
    <Styles.ProcessingContainer>
      <SpinnerLight />
      <Styles.ProcessingTextContainer>
        <Styles.ProcessingHeader>
          {i18n.t(`${TRANSLATION}.processing.title`)}
        </Styles.ProcessingHeader>
        <Styles.ProcessingDescription>
          {i18n.t(`${TRANSLATION}.processing.description`)}
        </Styles.ProcessingDescription>
      </Styles.ProcessingTextContainer>
    </Styles.ProcessingContainer>
  )
}
